import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { style } from '../../utils/style.js';
import { AtmsMap } from './AtmsMap.js';
import { OfficesMap } from './OfficesMap.js';
export const OfficesAtmsMap = JSX(({ data, className, ...rest }) => {
    const dataType = data?.dataType ?? 'offices';
    return (_jsx(BlockWrapper, { version: "transparent", className: style(className), defaultPadding: "p-0", ...rest, children: dataType === 'offices' ? _jsx(OfficesMap, {}) : _jsx(AtmsMap, { descriptionData: data }) }));
});
//# sourceMappingURL=OfficesAtmsMap.js.map